import axios from "axios";
import { API_URL,MEDIA_API_URL } from "../../constants";

export const UploadSubMedia = async (body,ApiStatus) => {
    ApiStatus({ isLoader: true, isError: false, data: null });
    const token = sessionStorage.getItem('LOGIN_TOKEN');
    try {
        let res = await axios.post(MEDIA_API_URL +"portfolio/upload_photo",body, {
            headers: {
                'Authorization': "Bearer " + token,
                'Content-Type': 'multipart/form-data;'
            },
            onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round(
                    (progressEvent.loaded / progressEvent.total)*100
                );
                ApiStatus({ isLoader: true, isError: false, data: null, process: percentCompleted, total: 100 });
            }
        });
        ApiStatus({ isLoader: false, isError: false, data: res.data });
    } catch (err) {
        ApiStatus({ isLoader: false, isError: true, data: null });
    }

}